export default "__VITE_ASSET__402254e3__"